import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-trophy-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-bold text-white font-heading tracking-wide">
                  {t('footer.company')}
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed mb-5 max-w-xs">
                {t('footer.description')}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                {t('footer.quicklinks')}
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('nav.home')}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('nav.about')}
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('footer.faq')}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('footer.privacy')}
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('footer.terms')}
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                {t('footer.categories')}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">
                {t('footer.support')}
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {t('footer.contactus')}
                  </a>
                </li>
                <li>
                  <span className="text-sm text-background-400">400-888-9999</span>
                </li>
                <li>
                  <span className="text-sm text-background-400">contact@kaiyuansports.com</span>
                </li>
                <li>
                  <span className="text-sm text-background-400">北京市朝阳区体育中心</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              {t('footer.copyright').replace('2024', String(currentYear))}
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}